module.exports = __webpack_public_path__ + "img/tu01.4c7ecc63.jpg";